import React from 'react';
import { assignIdsToStruc, groupKostenByPosition } from '../../../../../utils/helper';
import BerichtEvaluation, { GetBerichtEvaluationFormStruc } from './content/BerichtEvaluation';
import AnlagenVN, { GetAnlagenFormStrucVN } from './content/AnlagenVN';
import { get } from 'lodash';
import { Typography } from '@mui/material';
import { GetPersonalKostenVN } from './content/personalkosten/GetPersonalKostenVN';
import { GetSachkostenVN } from './content/sachkosten/GetSachkostenVN';
import { GetEigenmittelVN } from './content/eigenmittel/GetEigenmittelVN';
import AbschlussVN from './content/AbschlussVN';
import { GetSonstigesKostenVN } from './content/sonstige-kosten/GetSonstigeKostenVN';
import { GetDrittmittelVN } from './content/drittmittel/GetDrittmittelVN';

export const VerwendungsnachweisStructure = (application: any, kostenKategories: any) => {
	const KostenKategoriesGroup = groupKostenByPosition(kostenKategories);
	const STRUC: any[] = [
		{ label: 'Bericht und Evaluation', content: <BerichtEvaluation />, formStruc: GetBerichtEvaluationFormStruc() },
		...(get(KostenKategoriesGroup, 'Ausgabe', []).includes('Personalkosten')
			? [
					{
						label: 'Personalkosten',
						content: <Typography variant="h3">Personalkosten</Typography>,
						children: GetPersonalKostenVN(application, kostenKategories),
					},
				]
			: []),
		...(get(KostenKategoriesGroup, 'Ausgabe', []).includes('Sachkosten')
			? [
					{
						label: 'Sachkosten',
						content: <Typography variant="h3">Sachkosten</Typography>,
						children: GetSachkostenVN(application, kostenKategories),
					},
				]
			: []),
		...(get(KostenKategoriesGroup, 'Ausgabe', []).includes('SonstigeKosten')
			? [
					{
						label: 'Sonstige Kosten',
						content: <Typography variant="h3">Sonstige Kosten</Typography>,
						children: GetSonstigesKostenVN(application, kostenKategories),
					},
				]
			: []),
		...(get(KostenKategoriesGroup, 'Einnahme', []).includes('Eigenmittel')
			? [
					{
						label: 'Eigenmittel',
						content: <Typography variant="h3">Eigenmittel</Typography>,
						children: GetEigenmittelVN(application, kostenKategories),
					},
				]
			: []),
		...(get(KostenKategoriesGroup, 'Einnahme', []).includes('Drittmittel')
			? [
					{
						label: 'Drittmittel',
						content: <Typography variant="h3">Drittmittel</Typography>,
						children: GetDrittmittelVN(application, kostenKategories),
					},
				]
			: []),
		{ label: 'Anlagen', content: <AnlagenVN />, formStruc: GetAnlagenFormStrucVN() },
		{ label: 'Abschluss', content: <AbschlussVN /> },
	];

	return assignIdsToStruc(STRUC);
};
